import { MOST_POPULAR_CURRENCIES } from '@api-ui-app/src/app/lib/constants';

export function sortCurrencyCodes(currencyCodes: string[], mostPopularFirst = true) {
  if (!mostPopularFirst) {
    return currencyCodes.sort();
  }

  const mostPopular = MOST_POPULAR_CURRENCIES.filter(code => currencyCodes.includes(code));

  if (!mostPopular.length) {
    return currencyCodes.sort();
  }

  const lessPopular = currencyCodes.filter(code => !MOST_POPULAR_CURRENCIES.includes(code)).sort();

  return [...mostPopular, ...lessPopular];
}
